import { requestFromServer } from "./api-client";

const FarmerClient = {
	listByLoggedFarmer: async () => {
		return requestFromServer(`v1/Farms/listByLoggedFarmer`);
	}
};

export default FarmerClient;
